import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { YesNo } from 'constants/enums/yesNo.enum';
import commonService from 'utils/commonService';
import gameService from 'bff/services/gameService';
import { PrizeItem } from 'bff/models/game/gameQuery';
import ImageWithFallback from 'components/ImageWithFallback';
import { SlotMachineProps } from './types';
import { GameDodrawResp } from 'bff/models/game/gameDodraw';
import { DrawStatus } from 'constants/enums/drawStatus.enum';

// 旺旺電商處要求降低過場時間 (2025/03/10)
const slotConfig = {
  // duration: 5_000, // ms
  duration: 3_000,
  // rollingloop: 5
  rollingloop: 3
};

const SlotMachine: React.FC<SlotMachineProps> = (props) => {
  const [prizes, setPrizes] = useState<PrizeItem[]>([]);
  const [unitRotate, setUnitRotate] = useState<number>(0);
  const [response, setResponse] = useState<GameDodrawResp | null>(null);
  const [showPrizeResult, setPrizeResult] = useState<PrizeItem | null>(null);
  const [drawResult, setDrawResult] = useState<string>('');
  const [translateZ, setTranslateZ] = useState<number>(0);
  const [isRolling, setIsRolling] = useState<boolean>(false);
  const [rollingDeg, setRollingDeg] = useState<number>(0);
  const [prizeIndex, setPrizeIndex] = useState<number | null>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  /**
   * @description 頁面初始
   */
  useEffect(() => {
    window.addEventListener('resize', calculateTranslateZ);
    return () => {
      window.removeEventListener('resize', calculateTranslateZ);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * @description 當方案切換，重置旋轉角度、抽中獎項
   */
  useEffect(() => {
    setRollingDeg(0);
    setResponse(null);
    setPrizeResult(null);
  }, [props.gameID]);

  /**
   * @description 從抽獎結果更新中獎獎項
   */
  useEffect(() => {
    if (props.drawResult && props.gameSN === props.drawResult.SN) {
      const { prize } = props.drawResult;
      setPrizeResult(prize);
    }
  }, [props.drawResult, props.gameSN]);

  /**
   * @description 當方案變動，不到 6 個獎項需補到大於等於 6 個 (含「未中獎」1 個)，然後計算角度、距旋轉圓心距離
   */
  useEffect(() => {
    const blnItem = {
      SN: 0,
      GAME_ID: '',
      SHOW_ORDER: 0,
      ITEM_NAME: props.blnTitle,
      ITEM_IMAGE: props.blnImage,
      ITEM_DESC: props.blnDesc,
      ITEM_QTY: 1
    };
    if (props.prizes.length < 6) {
      const _prizes: PrizeItem[] = [];
      while (_prizes.length < 6) {
        for (let i = 0; i < props.prizes.length; i++) {
          const prizeItem = props.prizes[i];
          _prizes.push(_.cloneDeep(prizeItem));
        }
      }
      _prizes.push(blnItem);
      setUnitRotate(360 / _prizes.length);
      setPrizes(_prizes);
    } else {
      setUnitRotate(360 / props.prizes.length);
      const _prizes: PrizeItem[] = [];
      for (let i = 0; i < props.prizes.length; i++) {
        _prizes.push(_.cloneDeep(props.prizes[i]));
      }
      _prizes.push(blnItem);
      setPrizes(_prizes);
    }
    calculateTranslateZ();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, props.gameID, props.prizes]);

  /**
   * @description 啟動旋轉
   */
  const handleRollingStart = async () => {
    // 抽獎中或不可抽獎時
    if (isPlaying || props.drawStatus !== DrawStatus.D) return;
    // setDrawResult('');
    const response = await gameService.gameDodraw({ GAME_ID: props.gameID });
    if (response) {
      setIsPlaying(true);
      // setDrawResult(response.DRAW_RESULT);
      // const index = getPrizeIndex();
      let index = prizes.findIndex(it => it.SN === 0); // 未抽中獎項 index
      // 根據抽中獎項 SN，轉換為 index
      if (response.DRAW_RESULT === 'Y' && response.PRIZE.length > 0) {
        const winPrize = response.PRIZE[0];
        index = prizes.findIndex(it => it.SN === winPrize.SN);
      }
      setResponse(response);
      setPrizeIndex(index);
      rollingSlot(index);
      scrollToMachine();
    }
    // 前端測試(資料庫尚無資料的測試)
    // losingTest();
    // winningTest();
  };

  /**
   * @description 測試未抽中
   */
  const losingTest = () => {
    setIsPlaying(true);
    const index = prizes.findIndex(it => it.SN === 0);
    // 設定抽獎結果
    setResponse({
      GAME_ID: props.gameID,
      DRAW_RESULT: 'N',
      DRAW_CNT_AVAILABLE: 0,
      PRIZE: []
    });
    setPrizeIndex(index);
    rollingSlot(index);
    scrollToMachine();
  };

  /**
   * @description 測試第一獎項抽中
   * @param index 獎項索引
   */
  const winningTest = (index: number = 0) => {
    setIsPlaying(true);
    const winnerIndex = index;
    // 設定抽獎結果
    setResponse({
      GAME_ID: props.gameID,
      DRAW_RESULT: 'Y',
      DRAW_CNT_AVAILABLE: winnerIndex,
      PRIZE: []
    });
    setPrizeIndex(winnerIndex);
    rollingSlot(winnerIndex);
    scrollToMachine();
  };

  /**
   * @description 取得抽中獎項 index => 需呼叫抽獎 API 取得獎項並轉換成 index
   */
  // const getPrizeIndex = () => {
  //   return Math.round(Math.random() * 1000) % prizes.length;
  // };

  /**
   * @description 取得獎項的旋轉角度 (旋轉圈數依設定)
   * @param index 獎項 index
   */
  const rollingSlot = (index: number) => {
    setIsRolling(true);
    setRollingDeg(360 * slotConfig.rollingloop + index * unitRotate);
  };

  /**
   * @description 停止旋轉
   */
  const handleRollingEnd = () => {
    setIsRolling(false);
    // 根據中台回傳的獎項，設定旋轉角度與中獎資料
    if (prizeIndex !== null && prizeIndex >= 0) {
      setRollingDeg(prizeIndex * unitRotate);
      const _result = prizes[prizeIndex];
      // 設定至組件外部的狀態緩存
      // setPrizeResult(_result);
      if (response) setDrawResult(response.DRAW_RESULT);
      if (props.saveDrawResult && response) {
        props.saveDrawResult(props.gameSN, response, _result);
      }
      // 確保旋轉效果已結束後可正常執行滾動
      setTimeout(() => {
        scrollToResult();
        setIsPlaying(false);
        if (props.onRollingEnd) props.onRollingEnd(props.gameID);
      }, 300);
    }
  };

  /**
   * @description 滾動到拉霸機位置
   */
  const scrollToMachine = () => {
    const campaignMachine = document.querySelector('#slot-prize-machine');
    if (campaignMachine) {
      campaignMachine.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  /**
   * @description 滾動到抽獎結果位置
   */
  const scrollToResult = () => {
    const campaignContent = document.querySelector('#slot-prize-result');
    if (campaignContent) {
      campaignContent.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  /**
   * @description 根據高度與角度，計算旋轉的圓心距離(z 值)
   */
  const calculateTranslateZ = () => {
    const screenContent = document.querySelector('#slot-prize-screen');
    if (screenContent) {
      setTranslateZ(
        screenContent.clientHeight /
          2 /
          Math.tan((unitRotate / 2 / 180) * Math.PI) -
          1
      );
    }
  };

  return (
    <div className="slotMachine">
      <div className="slot">
        <div className="machine">
          <div className="back">
            <img
              src={require('assets/images/machine-back.png')}
              alt="slot machine back"
              onLoad={() => {
                calculateTranslateZ();
              }}
            />
          </div>
          <div id="slot-prize-screen" className="screen">
            <div
              className="content"
              style={{
                transform: `rotateX(${-rollingDeg}deg)`,
                // 為了維持旋轉速度，根據獎項個數計算
                // transition: isRolling
                //   ? `transform ${prizes.length * 1000}ms ease-in-out`
                //   : undefined
                transition: isRolling
                  ? `transform ${slotConfig.duration}ms ease-in-out`
                  : undefined
              }}
              onTransitionEnd={() => {
                handleRollingEnd();
              }}
            >
              {prizes.map((item, itemIndex) => {
                return (
                  <div
                    key={`prize-${itemIndex}`}
                    className="item"
                    style={{
                      transform: `rotateX(${
                        unitRotate * itemIndex
                      }deg) translateZ(${translateZ}px)`
                      // display: 'flex',
                      // justifyItems: 'center',
                      // alignItems: 'center'
                      // 加入背景色
                      // backgroundColor: '#F8ECD4'
                      // 圖片填入 div，避免跑版
                      // backgroundImage: `url(${commonService.convertImageUrl(item.ITEM_IMAGE)})`,
                      // backgroundRepeat: 'no-repeat',
                      // backgroundAttachment: 'fixed',
                      // backgroundPosition: 'center',
                      // backgroundSize: 'contain'
                    }}
                  >
                    {/* 若圖片載入失敗，則顯示錯誤訊息 */}
                    <ImageWithFallback
                      imageName={item.ITEM_NAME}
                      src={commonService.convertImageUrl(item.ITEM_IMAGE)}
                      alt={item.ITEM_NAME}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="front">
            <img src={require('assets/images/machine-front.png')} alt="slot machine front" />
          </div>
          {/* 按鈕組件 */}
          <button
            className="button"
            onMouseDown={() => {
              // 解決手機版 css 樣式失效的補強 (2025/03/10)
              $('#slotButtonNormal').css('display', 'none');
              $('#slotButtonActive').css('display', 'block');
            }}
            onClick={() => {
              handleRollingStart();
            }}
            onMouseUp={() => {
              // 解決手機版 css 樣式失效的補強 (2025/03/10)
              setTimeout(() => {
                $('#slotButtonNormal').css('display', 'block');
                $('#slotButtonActive').css('display', 'none');
              }, 200);
            }}
            title="Slot machine button"
            disabled={isRolling || props.drawStatus !== DrawStatus.D}
          >
            <img
              id="slotButtonNormal"
              className="image normal"
              src={require('assets/images/machine-button.png')}
              alt="slot machine button normal"
            />
            <img
              id="slotButtonActive"
              className="image active"
              src={require('assets/images/machine-button-active.png')}
              alt="slot machine button active"
            />
          </button>
          {/* 把手組件 */}
          <button
            className="handler"
            onMouseDown={() => {
              // 解決手機版 css 樣式失效的補強 (2025/03/10)
              $('#slotHandlerNormal').css('display', 'none');
              $('#slotHandlerHover').css('display', 'none');
              $('#slotHandlerActive').css('display', 'block');
            }}
            onClick={() => {
              handleRollingStart();
            }}
            onMouseUp={() => {
              setTimeout(() => {
                // 解決手機版 css 樣式失效的補強 (2025/03/10)
                $('#slotHandlerNormal').css('display', 'block');
                $('#slotHandlerActive').css('display', 'none');
              }, 200);
            }}
            title="Slot machine handler"
            disabled={isRolling || props.drawStatus !== DrawStatus.D}
          >
            <img
              id="slotHandlerNormal"
              className="image normal"
              src={require('assets/images/machine-handler.png')}
              alt="slot machine handler normal"
            />
            <img
              id="slotHandlerHover"
              className="image hover"
              src={require('assets/images/machine-handler-hover.png')}
              alt="slot machine handler hover"
            />
            <img
              id="slotHandlerActive"
              className="image active"
              src={require('assets/images/machine-handler-active.png')}
              alt="slot machine handler acitve"
            />
          </button>
        </div>
        {/* 移動抽獎結果錨點到此處 */}
        <div id="slot-prize-result" className="times">
          <span className="title">可抽獎次數：</span>
          <span className="emphsis">{props.drawCount}</span>
          <span> 次</span>
        </div>
      </div>
      <div className="prize">
        {showPrizeResult && showPrizeResult.SN >= 0 ? (
          <div className="content">
            <div className="photo">
              {/* <img src={commonService.convertImageUrl(showPrizeResult.ITEM_IMAGE)} alt="prize" /> */}
              <ImageWithFallback
                imageName={showPrizeResult.ITEM_NAME}
                src={commonService.convertImageUrl(showPrizeResult.ITEM_IMAGE)}
                alt={showPrizeResult.ITEM_NAME}
              />
            </div>
            {/* 旺旺電商處指出此處視覺稿與 wireframe 不符合，故前端重新調整 (2025/03/10) */}
            <div className="context">
              {drawResult === YesNo.Yes && (
                <h2 className="title congratulation">
                  恭喜中獎
                </h2>
              )}
              {drawResult === YesNo.No && (
                <h2 className="title pity">
                  很遺憾，未中獎
                </h2>
              )}
              <div className="sep-line" />
              {/* 獎項內容 */}
              <div className="prize-container">
                {/* 獎項名稱 */}
                <p className="prize-name">
                  {showPrizeResult.ITEM_NAME}
                </p>
                {/* 獎項說明 */}
                <p className="prize-desc">
                  {showPrizeResult.ITEM_DESC}
                </p>
              </div>
            </div>
          </div>
        ) : (
          []
        )}
        <div className="buttonGroup">
          {showPrizeResult && showPrizeResult.SN >= 0 ? (
            <>
              <button
                className={'button noted' + (isPlaying ? ' isPlaying' : '')}
                title="Noted"
                onClick={() => {
                  if (props.onIKnow) props.onIKnow();
                }}
              >
                我知道了
              </button>
              <button
                className={'button play' + (isPlaying || props.drawStatus !== DrawStatus.D ? ' isPlaying' : '')}
                title="Re-play"
                onClick={() => {
                  handleRollingStart();
                }}
              >
                再抽一次
              </button>
            </>
          ) : (
            null
            // 旺旺電商處要求移除 (2025/03/10)
            // <button
            //   className={'button play' + (isPlaying || props.drawStatus !== DrawStatus.D ? ' isPlaying' : '')}
            //   title="play"
            //   onClick={() => {
            //     handleRollingStart();
            //   }}
            // >
            //   馬上抽獎
            // </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SlotMachine;
